import { apiInstance } from 'api/utils';
import { CustomerType } from 'store/modules/Customers/types';

export default {
  createRiskProfile: ({
    portfolio,
    time_horizon_interval,
    required_return,
    risk_tolerance,
    risk_capacity,
    knowledge_level,
    recommended_risk_profile,
    customer,
    selected_cip,
    knowledge_level_description,
    knowledge,
    experience,
    composure
  }: {
    portfolio?: string;
    time_horizon_interval: any;
    required_return: string;
    risk_tolerance: string;
    risk_capacity: string;
    knowledge_level?: string;
    recommended_risk_profile: string;
    customer: CustomerType;
    selected_cip: string;
    knowledge_level_description?: string;
    knowledge?: number;
    composure?: number;
    experience?: number;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/risk-profiles/`,
      data: {
        customer: customer,
        time_horizon_interval,
        required_return,
        risk_tolerance,
        risk_capacity: risk_capacity === null ? null : -Number(risk_capacity),
        knowledge_level: knowledge_level,
        recommended_risk_profile: recommended_risk_profile,
        selected_cip,
        knowledge_level_description,
        knowledge,
        composure,
        experience
      }
    });
  },
  getRiskSummaries: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/risk-profiles/`
    });
  },
  updateRiskSummary: ({
    portfolio,
    customer,
    riskProfileId,
    risk_tolerance
  }: {
    portfolio: any;
    riskProfileId: string;
    customer: CustomerType;
    risk_tolerance: string;
  }) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/cases/${portfolio}/risk-profiles/${riskProfileId}/`,
      data: {
        customer,
        risk_tolerance
      }
    });
  },
  updateRiskSummary2: ({
    portfolio,
    riskProfileId,
    data
  }: {
    portfolio: any;
    riskProfileId: string;
    data: any;
  }) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/cases/${portfolio}/risk-profiles/${riskProfileId}/`,
      data: data
    });
  }
};
